import { TextField } from 'mui-rff';
import React from 'react';

import { type MuiStackField } from '@dashboard/components/form/fields/StackField';
import { PlatformSendingStatus } from '@dashboard/generated/wp/authentication';
import { useVerifiedEmailAddressesQuery } from '@dashboard/generated/wp/platform';
import useCurrentWpPlatform from '@dashboard/hooks/useCurrentWpPlatform';
import { MenuItem, TextField as MuiTextField } from '@mui/material';
import { DEFAULT_WAYPOINT_TESTER_SENDER_CONTACT } from '@wp-constants/emailSending';

type BaseProps = Pick<
  Parameters<typeof MuiStackField>[0],
  'variant' | 'label' | 'helperText' | 'FormHelperTextProps' | 'placeholder'
>;
type Props = BaseProps & { name: string };

export default function SenderSelectField({
  name,
  variant,
  label,
  helperText,
  FormHelperTextProps,
  placeholder,
}: Props) {
  const { data } = useVerifiedEmailAddressesQuery();
  const verifiedEmailAddressesNodes = data?.VerifiedEmailAddresses.nodes;
  const { data: pData } = useCurrentWpPlatform();
  const sendingStatus = pData?.Platform.sendingStatus;

  const commonProps = {
    FormHelperTextProps,
    fullWidth: true,
    variant,
    label,
    helperText,
    placeholder,
    margin: 'normal',
    size: 'small',
  } as const;

  if (!verifiedEmailAddressesNodes || !sendingStatus) {
    return <MuiTextField disabled {...commonProps} InputLabelProps={{ shrink: true }} />;
  }

  const defaultMenuItem = function () {
    if (sendingStatus === PlatformSendingStatus.LiveMode && verifiedEmailAddressesNodes.length > 0) {
      return null;
    }
    return <MenuItem value="">{DEFAULT_WAYPOINT_TESTER_SENDER_CONTACT}</MenuItem>;
  };

  return (
    <>
      <TextField select SelectProps={{ displayEmpty: true }} name={name} {...commonProps}>
        {defaultMenuItem()}
        {verifiedEmailAddressesNodes.map((v) => (
          <MenuItem key={v.id} value={v.id}>
            {v.value}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}
